"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Sortable = function () {
  function Sortable(cellWidth, cellHeight, cellSpacing, mode, cells, isDropOnEmptyAreaAllowed) {
    _classCallCheck(this, Sortable);

    // console.log("sortable new")
    cells = cells ? cells : []; //default_order
    this.state = {
      mode: mode ? mode : "SORT", // default, SORT
      // size_mode: "SWAP", // default, stick
      cellSpacing: cellSpacing ? cellSpacing : 5,
      cellWidth: cellWidth ? cellWidth : 90,
      cellHeight: cellHeight ? cellHeight : 90,
      mouseX: 0,
      mouseY: 0,
      // lastPress: -1,
      isPressed: false,
      // currentRow:-1,
      // currentCol:-1,
      cells: this.clone(cells),
      old_order: this.clone(cells),
      init_size: this.get_init_size(cells),
      isDropOnEmptyAreaAllowed: isDropOnEmptyAreaAllowed ? isDropOnEmptyAreaAllowed : false
    };
  }

  _createClass(Sortable, [{
    key: "clone",
    value: function clone(obj) {
      //// eslint-disable-next-line
      var newObj = obj instanceof Array ? [] : {};
      var i;
      for (i in obj) {
        if (i === 'clone') continue;
        if (obj[i] && _typeof(obj[i]) === "object") {
          newObj[i] = this.clone(obj[i]);
        } else newObj[i] = obj[i];
      }return newObj;
    }
  }, {
    key: "uuidv4",
    value: function uuidv4() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
      });
    }
  }, {
    key: "add_item_right_col",
    value: function add_item_right_col() {
      var defaultColumn = this.get_right_column_average(1);
      this.state.cells.push({ id: this.uuidv4(), colspan: 1, rowspan: 1, defaultColumn: defaultColumn + 1, defaultRow: 1, content: String(this.state.cells.length + 1) });
      this.state.old_order = this.clone(this.state.cells);
    }
  }, {
    key: "add_item_end_row",
    value: function add_item_end_row() {
      var copy_order = this.state.cells;
      var max_row = 0;
      copy_order.forEach(function (value, key) {
        if (value.defaultRow >= max_row) {
          max_row = value.defaultRow;
        }
      });
      this.state.cells.push({ id: this.uuidv4(), colspan: 1, rowspan: 1, defaultColumn: 1, defaultRow: max_row + 1, content: String(this.state.cells.length + 1) });
      this.state.old_order = this.clone(this.state.cells);
    }
  }, {
    key: "get_init_size",
    value: function get_init_size(cells) {
      var result = {};
      var copy_order = Object.assign([], cells);
      copy_order.forEach(function (value, key) {
        if (value.rowspan > 1 || value.colspan > 1) {
          result[value.defaultRow + "_" + value.defaultColumn] = { colspan: value.colspan, rowspan: value.rowspan, defaultColumn: value.defaultColumn, defaultRow: value.defaultRow };
        }
      });
      // console.log("get_init_size::", result)
      return result;
    }
  }, {
    key: "clamp",
    value: function clamp(n, min, max) {
      return Math.max(Math.min(n, max), min);
    }
  }, {
    key: "get_state",
    value: function get_state() {
      // let temp = this.state
      var res_order = [];
      var copy = Object.assign({}, this.state);
      copy.cells.forEach(function (value, key) {
        var ttm = value;
        ttm.width = ttm.colspan * copy.cellWidth + (ttm.colspan - 1) * copy.cellSpacing;
        ttm.height = ttm.rowspan * copy.cellHeight + (ttm.rowspan - 1) * copy.cellSpacing;
        ttm.y = ttm.defaultRow * (copy.cellHeight + copy.cellSpacing);
        ttm.x = ttm.defaultColumn * (copy.cellWidth + copy.cellSpacing);
        res_order.push(ttm);
      });
      copy.cells = res_order;
      return copy;
    }
  }, {
    key: "get_left_column_without_cur",
    value: function get_left_column_without_cur(defaultRow) {
      var _this = this;

      // console.log("row_______:::", defaultRow)
      var max_column = 0;
      // const {lastPress} = this.state;
      // let copy = Object.assign({}, this.state);
      // copy.cells.forEach((value, key_y) => {
      //   //|| defaultRow === (value.defaultRow + value.rowspan - 1)
      //   if(defaultRow === value.defaultRow){
      //     if(value.defaultColumn >= max_column){
      //       if(lastPress.id !== value.id){
      //         console.log("get_right_column_without_cur:::", value)
      //         max_column = value.defaultColumn + (value.colspan-1)
      //       }
      //     }
      //   }
      // })
      // max_column = this.get_right_column_average(defaultRow)
      // console.log("max_right_col", max_right_col)
      var min_col = 0;
      Object.keys(this.state.init_size).forEach(function (str_key, key) {
        var value = _this.state.init_size[str_key];
        if (defaultRow > value.defaultRow && defaultRow < value.defaultRow + value.rowspan) {
          if (min_col > value.defaultColumn) {
            min_col = value.defaultColumn;
          }
          // console.log("max_right_col::", max_right_col)
          // console.log("(value.defaultColumn+value.colspan)::", (value.defaultColumn+value.colspan))
          if (max_column < value.defaultColumn + value.colspan && value.defaultColumn === 1
          // (value.defaultColumn+value.colspan) <= max_right_col
          ) {
              max_column = value.defaultColumn + value.colspan - 1;
            }
        }
      });
      if (min_col > 1) {
        return 0;
      } else {
        return max_column;
      }
      // console.log("get_right_column_without_cur::@@@@@::", max_column)
    }
  }, {
    key: "get_right_column_without_cur",
    value: function get_right_column_without_cur(defaultRow) {
      var _this2 = this;

      // console.log("row_______:::", defaultRow)
      var max_column = 0;
      var lastPress = this.state.lastPress;

      var copy = Object.assign({}, this.state);
      copy.cells.forEach(function (value, key_y) {
        //|| defaultRow === (value.defaultRow + value.rowspan - 1)
        if (defaultRow === value.defaultRow) {
          if (value.defaultColumn >= max_column) {
            if (lastPress.id !== value.id) {
              // console.log("get_right_column_without_cur:::", value)
              max_column = value.defaultColumn + (value.colspan - 1);
            }
          }
        }
      });
      var max_right_col = this.get_right_column_average(defaultRow);
      // console.log("max_right_col", max_right_col)
      Object.keys(this.state.init_size).forEach(function (str_key, key) {
        var value = _this2.state.init_size[str_key];
        if (defaultRow > value.defaultRow && defaultRow < value.defaultRow + value.rowspan) {
          // console.log("max_right_col::", max_right_col)
          // console.log("(value.defaultColumn+value.colspan)::", (value.defaultColumn+value.colspan))
          if (max_column < value.defaultColumn + value.colspan && value.defaultColumn + value.colspan <= max_right_col) {
            max_column = value.defaultColumn + value.colspan - 1;
          }
        }
      });
      // console.log("get_right_column_without_cur::@@@@@::", max_column)
      return max_column;
    }
  }, {
    key: "get_right_column",
    value: function get_right_column(defaultRow) {
      var max_column = 0;
      var copy = Object.assign({}, this.state);
      copy.cells.forEach(function (value, key_y) {
        if (defaultRow === value.defaultRow) {
          if (value.defaultColumn >= max_column) {
            max_column = value.defaultColumn;
          }
        }
      });
      return max_column;
    }
  }, {
    key: "get_right_column_average",
    value: function get_right_column_average(defaultRow) {
      var max_column = 0;
      var copy = Object.assign({}, this.state);
      copy.old_order.forEach(function (value, key_y) {
        if (defaultRow >= value.defaultRow) {
          if (value.defaultColumn + value.colspan - 1 >= max_column) {
            max_column = value.defaultColumn + value.colspan - 1;
          }
        }
      });
      return max_column;
    }
  }, {
    key: "item_in_init_size_right",
    value: function item_in_init_size_right(item) {
      var _this3 = this;

      var result = null;
      var value = void 0;
      Object.keys(this.state.init_size).forEach(function (str_key, key) {
        value = _this3.state.init_size[str_key];
        if (item.defaultRow > value.defaultRow && item.defaultRow < value.defaultRow + value.rowspan) {
          if (item.defaultColumn + 1 >= value.defaultColumn && item.defaultColumn + 1 < value.defaultColumn + value.colspan) {
            result = value;
          }
        }
      });
      return result;
    }
  }, {
    key: "item_in_init_size_left",
    value: function item_in_init_size_left(item) {
      var _this4 = this;

      var result = null;
      var value = void 0;
      Object.keys(this.state.init_size).forEach(function (str_key, key) {
        value = _this4.state.init_size[str_key];
        if (item.defaultRow > value.defaultRow && item.defaultRow < value.defaultRow + value.rowspan) {
          if (item.defaultColumn - 1 >= value.defaultColumn && item.defaultColumn - 1 < value.defaultColumn + value.colspan) {
            result = value;
          }
        }
      });
      return result;
    }
  }, {
    key: "move_item_right",
    value: function move_item_right(item, width) {
      var _this5 = this;

      //console.log("move_item_right", item, ">>>", width)
      var check_ava = void 0;
      this.state.cells.forEach(function (value, key) {
        if (item.id === value.id) {
          if (_this5.state.mode === "SORT") {
            var max_column = _this5.get_right_column(value.defaultRow);
            // console.log("..........................................")
            // console.log("max_column::::::::::::::::::::", max_column)
            if (max_column === value.defaultColumn) {
              // console.log("this.get_left_column_without_cur(value.defaultRow)!!!", value.defaultRow, " ! ", this.get_left_column_without_cur(value.defaultRow+1))

              // value.defaultColumn = 1
              value.defaultColumn = _this5.get_left_column_without_cur(value.defaultRow + 1) + 1;
              value.defaultRow += 1;
            } else {
              check_ava = _this5.item_in_init_size_right(value);
              // console.log("==================")
              // console.log("check_ava:::", check_ava)
              if (check_ava) {
                value.defaultColumn += check_ava.colspan + 1;
              } else {
                value.defaultColumn += width;
              }
            }
            // value.colspan = 1
            // value.rowspan = 1
            value.colspan = 1;
            value.rowspan = 1;
            var size = void 0,
                is_not_move = void 0;
            if (_this5.state.init_size[value.defaultRow + "_" + (value.defaultColumn - 1)]) {
              size = _this5.state.init_size[value.defaultRow + "_" + (value.defaultColumn - 1)];
              is_not_move = false;
            }
            if (_this5.state.init_size[value.defaultRow + "_" + value.defaultColumn]) {
              size = _this5.state.init_size[value.defaultRow + "_" + value.defaultColumn];
              is_not_move = true;
            }
            if (size) {
              value.rowspan = size.rowspan;
              value.colspan = size.colspan;
              value.width = value.colspan * _this5.state.cellWidth + (value.colspan - 1) * _this5.state.cellSpacing;
              value.height = value.rowspan * _this5.state.cellHeight + (value.rowspan - 1) * _this5.state.cellSpacing;
              if (!is_not_move) {
                _this5.move_item_right(value, 1);
              }
            }
          } else {
            value.defaultColumn += width;
          }
        }
      });
    }
  }, {
    key: "is_left_nothing",
    value: function is_left_nothing(defaultRow, search_col) {
      var _this6 = this;

      var res = false;
      // console.log("this.state.init_size::", this.state.init_size, defaultRow, search_col)
      Object.keys(this.state.init_size).forEach(function (value, key) {
        // console.log("value:", value)
        // console.log("key:", key)
        var res_is_owner = false;
        var lastPress = _this6.state.init_size[value];
        if (defaultRow >= lastPress.defaultRow && defaultRow < lastPress.defaultRow + lastPress.rowspan) {
          if (search_col >= lastPress.defaultColumn && search_col < lastPress.defaultColumn + lastPress.colspan + 1) {
            res_is_owner = true;
          }
        }
        if (res_is_owner && defaultRow !== lastPress.defaultRow && search_col !== lastPress.defaultColumn) {
          // console.log("res_is_owner:", res_is_owner, search_col, lastPress, (search_col - lastPress.colspan ))
          if (search_col - lastPress.colspan === 1) {
            res = true;
          }
        }
      });
      if (res || search_col === 1) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "move_item_left",
    value: function move_item_left(item, width) {
      var _this7 = this;

      // console.log("move_item_left::", item.defaultColumn, "__", item.defaultRow, ">>>", width)
      var check_ava = void 0;
      this.state.cells.forEach(function (value, key) {
        if (item.id === value.id) {
          if (_this7.state.mode === "SORT") {
            // console.log("is_left_nothing::::", this.is_left_nothing(value.defaultRow, value.defaultColumn))
            // if(value.defaultColumn === 1){
            if (_this7.is_left_nothing(value.defaultRow, value.defaultColumn)) {
              // console.log("this.get_right_column_without_cur(value.defaultRow)!!!", value.defaultRow, " ! ", this.get_right_column_without_cur(value.defaultRow-1))
              value.defaultColumn = _this7.get_right_column_without_cur(value.defaultRow - 1) + 1;
              value.defaultRow -= 1;
              // value.defaultColumn = (this.get_right_column_without_cur(value.defaultRow)+1)
            } else {
              check_ava = _this7.item_in_init_size_left(value);
              // console.log("check_ava::", check_ava)
              if (check_ava) {
                value.defaultColumn -= check_ava.colspan + 1;
              } else {
                value.defaultColumn -= width;
              }
            }
            value.colspan = 1;
            value.rowspan = 1;
            var size = void 0,
                is_not_move = void 0;
            if (_this7.state.init_size[value.defaultRow + "_" + (value.defaultColumn - 1)]) {
              size = _this7.state.init_size[value.defaultRow + "_" + (value.defaultColumn - 1)];
              is_not_move = false;
            }
            if (_this7.state.init_size[value.defaultRow + "_" + value.defaultColumn]) {
              size = _this7.state.init_size[value.defaultRow + "_" + value.defaultColumn];
              is_not_move = true;
            }

            if (size) {
              value.rowspan = size.rowspan;
              value.colspan = size.colspan;
              value.width = value.colspan * _this7.state.cellWidth + (value.colspan - 1) * _this7.state.cellSpacing;
              value.height = value.rowspan * _this7.state.cellHeight + (value.rowspan - 1) * _this7.state.cellSpacing;
              if (!is_not_move) {
                // console.log("move_item_left............")
                _this7.move_item_left(value, 1);
              }
            }
          } else {
            value.defaultColumn -= width;
          }
        }
      });
    }
  }, {
    key: "move_item_bottom",
    value: function move_item_bottom(item, width) {
      //console.log("move_item_bottom", item, "-----", width)
      this.state.cells.forEach(function (value, key) {
        if (item.id === value.id) {
          value.defaultRow += width;
        }
      });
    }
  }, {
    key: "move_item_top",
    value: function move_item_top(item, width) {
      //console.log("move_item_bottom", item, "-----", width)
      this.state.cells.forEach(function (value, key) {
        if (item.id === value.id) {
          value.defaultRow -= width;
        }
      });
    }
  }, {
    key: "available_item_on_old_order",
    value: function available_item_on_old_order(defaultRow, defaultColumn) {
      //console.log("------------------")
      // console.log("available_item", defaultColumn, defaultRow,  this.state.old_order, this.state.cells)
      // const {lastPress} = this.state;
      // let item_cur = this.get_item_id(lastPress.id)
      var copy = Object.assign({}, this.state);
      var count = 0;
      copy.old_order.forEach(function (value, key_y) {
        if (
        // item_cur.id !== value.id &&
        value.defaultColumn <= defaultColumn && value.defaultColumn + value.colspan > defaultColumn && value.defaultRow <= defaultRow && value.defaultRow + value.rowspan > defaultRow) {
          // console.log("available_item:::value::", value)
          count += 1;
        }
      });

      if (count > 0) {
        return false;
      } else {

        return true;
      }
    }
  }, {
    key: "available_item",
    value: function available_item(defaultRow, defaultColumn) {
      // console.log("------------÷------")
      // console.log("available_item", defaultColumn, defaultRow,  this.state.old_order, this.state.cells)
      var lastPress = this.state.lastPress;

      var item_cur = this.get_item_id(lastPress.id);
      var copy = Object.assign({}, this.state);
      var count = 0;
      copy.cells.forEach(function (value, key_y) {
        if (item_cur.id !== value.id && value.defaultColumn <= defaultColumn && value.defaultColumn + value.colspan > defaultColumn && value.defaultRow <= defaultRow && value.defaultRow + value.rowspan > defaultRow) {
          //console.log("available_item:::value::", value)
          count += 1;
        }
      });
      // console.log("count::::", count)
      if (count > 0) {
        return false;
      } else {
        if (!this.state.isDropOnEmptyAreaAllowed) {
          // console.log("available_item_on_old_order:::", this.available_item_on_old_order(defaultRow, defaultColumn), this.state.isDropOnEmptyAreaAllowed)

          if (!this.available_item_on_old_order(defaultRow, defaultColumn)) {
            // console.log("return true")
            var max_right_col = this.get_right_column_average(defaultRow);
            if (defaultColumn + item_cur.colspan - 1 <= max_right_col) {
              return true;
            } else {
              return false;
            }
            // if(this.cur_item_myself(defaultRow, defaultColumn)){
            //   return false
            // }else{
            //   return true
            // }
            // return true
          } else {
            return false;
          }
        } else {
          return true;
        }
      }
    }
  }, {
    key: "verify_is_owner",
    value: function verify_is_owner(defaultRow, defaultColumn) {
      var lastPress = this.state.lastPress;

      var res_is_owner = false;

      if (defaultRow >= lastPress.defaultRow && defaultRow < lastPress.defaultRow + lastPress.rowspan) {
        if (defaultColumn >= lastPress.defaultColumn && defaultColumn < lastPress.defaultColumn + lastPress.colspan) {
          res_is_owner = true;
        }
      }
      return res_is_owner;
    }
  }, {
    key: "available_item_left_right",
    value: function available_item_left_right(defaultRow, defaultColumn) {
      //console.log("available_item_left_right", defaultColumn, defaultRow)
      var lastPress = this.state.lastPress;

      //verify is move to myself

      var res_is_owner = this.verify_is_owner(defaultRow, defaultColumn);
      if (res_is_owner) {
        return false;
      }

      var item_cur = this.get_item_id(lastPress.id);
      var copy = Object.assign({}, this.state);
      var count = 0;
      copy.cells.forEach(function (value, key_y) {
        if (item_cur.id !== value.id && value.defaultColumn <= defaultColumn && value.defaultColumn + value.colspan > defaultColumn && value.defaultRow <= defaultRow && value.defaultRow + value.rowspan > defaultRow) {
          count += 1;
        }
      });

      var max_column = this.get_right_column_without_cur(defaultRow);
      if (max_column === 0 || count > 0) {
        if (max_column === 0) {
          //console.log("available_item_left_right:::", this.available_item_on_old_order(defaultRow, defaultColumn), this.state.isDropOnEmptyAreaAllowed)
          if (this.state.isDropOnEmptyAreaAllowed) {
            if (this.available_item_on_old_order(defaultRow, defaultColumn)) {
              return true;
            } else {
              return false;
            }
          }
        }
        return false;
      } else {
        var max_column_average = this.get_right_column_average(defaultRow);
        // console.log("max_column::::", max_column, max_column_average, defaultColumn)
        if (max_column + 1 !== max_column_average) {
          if (max_column + 1 < defaultColumn && defaultColumn <= max_column_average) {
            return false;
          }
        }
        return true;
      }
    }
  }, {
    key: "when_available_item_left_right",
    value: function when_available_item_left_right(defaultRow, defaultColumn) {
      //console.log("available_item_left_right", defaultColumn, defaultRow)
      var lastPress = this.state.lastPress;

      //verify is move to myself

      var res_is_owner = this.verify_is_owner(defaultRow, defaultColumn);
      if (res_is_owner) {
        return false;
      }

      var item_cur = this.get_item_id(lastPress.id);
      var copy = Object.assign({}, this.state);
      var count = 0;
      var search_value = null;
      copy.cells.forEach(function (value, key_y) {
        if (item_cur.id !== value.id && value.defaultColumn <= defaultColumn && value.defaultColumn + value.colspan > defaultColumn && value.defaultRow <= defaultRow && value.defaultRow + value.rowspan > defaultRow) {
          count += 1;
          // console.log("value::value::", value)
          search_value = value;
        }
      });
      if (count === 1) {
        return search_value;
      } else {
        return null;
      }
    }
  }, {
    key: "available_item_left",
    value: function available_item_left(item, width) {
      //console.log("available_item_left", item, width)
      var lastPress = this.state.lastPress;

      var item_on = this.get_item_id(item.id);
      var copy = Object.assign({}, this.state);
      var count = 0;
      copy.cells.forEach(function (value, key_y) {
        Array.from(Array(value.rowspan).keys()).forEach(function (rowspan, key_h) {
          //console.log("......", rowspan+1)
          Array.from(Array(value.colspan).keys()).forEach(function (colspan, key_w) {
            if (lastPress.id !== value.id && item.id !== value.id && value.defaultColumn + colspan >= item_on.defaultColumn - 1 && value.defaultColumn + colspan <= item_on.defaultColumn + item_on.colspan - 1 && value.defaultRow + rowspan >= item_on.defaultRow && value.defaultRow + rowspan <= item_on.defaultRow + (item_on.rowspan - 1)) {
              count += 1;
            }
          });
        });
      });
      if (count > 0) {
        return false;
      } else {
        return true;
      }
    }
  }, {
    key: "available_item_right",
    value: function available_item_right(item, width) {
      //console.log("available_item_right", item, width)
      var lastPress = this.state.lastPress;

      var item_on = this.get_item_id(item.id);
      //console.log("item_onlie", item_on)
      var copy = Object.assign({}, this.state);
      var count = 0;
      copy.cells.forEach(function (value, key_y) {
        Array.from(Array(value.rowspan).keys()).forEach(function (rowspan, key_h) {
          //console.log("......", rowspan+1)
          Array.from(Array(value.colspan).keys()).forEach(function (colspan, key_w) {
            //console.log("......", colspan+1)
            if (lastPress.id !== value.id && item.id !== value.id && value.defaultColumn + colspan >= item_on.defaultColumn && value.defaultColumn + colspan <= item_on.defaultColumn + item_on.colspan && value.defaultRow + rowspan >= item_on.defaultRow && value.defaultRow + rowspan <= item_on.defaultRow + (item_on.rowspan - 1)) {
              count += 1;
            }
          });
        });
      });
      if (count > 0) {
        return false;
      } else {
        return true;
      }
    }
  }, {
    key: "available_item_bottom",
    value: function available_item_bottom(item, width) {
      //console.log("available_item_bottom", item, width)
      var lastPress = this.state.lastPress;

      var item_on = this.get_item_id(item.id);
      // console.log("item_onlie", item_on)
      var copy = Object.assign({}, this.state);
      var count = 0;
      copy.cells.forEach(function (value, key_y) {
        Array.from(Array(value.rowspan).keys()).forEach(function (rowspan, key_h) {
          //console.log("......", rowspan+1)
          Array.from(Array(value.colspan).keys()).forEach(function (colspan, key_w) {
            if (lastPress.id !== value.id && item.id !== value.id && value.defaultColumn + colspan >= item_on.defaultColumn && value.defaultColumn + colspan <= item_on.defaultColumn + item_on.colspan - 1 && value.defaultRow + rowspan >= item_on.defaultRow && value.defaultRow + rowspan <= item_on.defaultRow + (item_on.rowspan - 1) + 1) {
              count += 1;
            }
          });
        });
      });
      if (count > 0) {
        return false;
      } else {
        return true;
      }
    }
  }, {
    key: "available_item_top",
    value: function available_item_top(item, width) {
      //console.log("available_item_top", item, width)
      var lastPress = this.state.lastPress;

      var item_on = this.get_item_id(item.id);
      var copy = Object.assign({}, this.state);
      var count = 0;
      copy.cells.forEach(function (value, key_y) {
        Array.from(Array(value.rowspan).keys()).forEach(function (rowspan, key_h) {
          //console.log("......", rowspan+1)
          Array.from(Array(value.colspan).keys()).forEach(function (colspan, key_w) {
            if (lastPress.id !== value.id && item.id !== value.id && value.defaultColumn + colspan >= item_on.defaultColumn && value.defaultColumn + colspan <= item_on.defaultColumn + item_on.colspan - 1 && value.defaultRow + rowspan >= item_on.defaultRow - 1 && value.defaultRow + rowspan <= item_on.defaultRow + (item_on.rowspan - 1)) {
              count += 1;
            }
          });
        });
      });
      if (count > 0) {
        return false;
      } else {
        return true;
      }
    }
  }, {
    key: "move_item_on_current_row_col",
    value: function move_item_on_current_row_col(currentRow, currentCol) {
      var _this8 = this;

      var lastPress = this.state.lastPress;

      this.state.cells.forEach(function (value, key) {
        if (lastPress.id === value.id) {

          value.defaultColumn = currentCol;
          value.defaultRow = currentRow;
          if (_this8.state.mode === "SORT") {
            value.rowspan = 1;
            value.colspan = 1;
            var size = void 0;
            if (_this8.state.init_size[value.defaultRow + "_" + value.defaultColumn]) {
              size = _this8.state.init_size[value.defaultRow + "_" + value.defaultColumn];
              // is_not_move = true
            }
            if (size) {
              value.rowspan = size.rowspan;
              value.colspan = size.colspan;
              value.width = value.colspan * _this8.state.cellWidth + (value.colspan - 1) * _this8.state.cellSpacing;
              value.height = value.rowspan * _this8.state.cellHeight + (value.rowspan - 1) * _this8.state.cellSpacing;
            }
          }
        }
      });
    }
  }, {
    key: "get_item_left",
    value: function get_item_left(currentRow, currentCol) {
      var _this9 = this;

      //console.log("get_item_left::", currentRow, currentCol)
      var lastPress = this.state.lastPress;

      var copy = Object.assign({}, this.state);
      var result = [];
      copy.cells.forEach(function (value, key_y) {
        if (lastPress.id !== value.id) {
          if (value.defaultColumn >= currentCol && value.defaultColumn <= currentCol + _this9.state.colspan - 1 && value.defaultRow >= currentRow && value.defaultRow <= currentRow + (_this9.state.rowspan - 1)) {
            result.push(value);
          }
        }
      });
      return result;
    }
  }, {
    key: "get_item_right",
    value: function get_item_right(currentRow, currentCol) {
      var _this10 = this;

      //console.log("get_item_right::", currentRow, currentCol)
      var lastPress = this.state.lastPress;

      var copy = Object.assign({}, this.state);
      var result = [];
      copy.cells.forEach(function (value, key_y) {
        if (lastPress.id !== value.id) {
          if (value.defaultColumn >= currentCol && value.defaultColumn <= currentCol + _this10.state.colspan - 1 && value.defaultRow >= currentRow && value.defaultRow <= currentRow + (_this10.state.rowspan - 1)) {
            result.push(value);
          }
        }
      });
      return result;
    }
  }, {
    key: "get_item_top",
    value: function get_item_top(currentRow, currentCol) {
      var _this11 = this;

      //console.log("get_item_top::", currentRow, currentCol)
      var lastPress = this.state.lastPress;

      var copy = Object.assign({}, this.state);
      var result = [];
      copy.cells.forEach(function (value, key_y) {
        if (lastPress.id !== value.id) {
          if (value.defaultRow >= currentRow && value.defaultRow <= currentRow + _this11.state.rowspan - 1 && value.defaultColumn >= currentCol && value.defaultColumn <= currentCol + (_this11.state.colspan - 1)) {
            result.push(value);
          }
        }
      });
      return result;
    }
  }, {
    key: "get_item_bottom",
    value: function get_item_bottom(currentRow, currentCol) {
      var _this12 = this;

      //console.log("get_item_bottom::", currentRow, currentCol)
      var lastPress = this.state.lastPress;

      var copy = Object.assign({}, this.state);
      var result = [];
      copy.cells.forEach(function (value, key_y) {
        if (lastPress.id !== value.id) {
          if (value.defaultRow >= currentRow && value.defaultRow <= currentRow + _this12.state.rowspan - 1 && value.defaultColumn >= currentCol && value.defaultColumn <= currentCol + (_this12.state.colspan - 1)) {
            result.push(value);
          }
        }
      });
      return result;
    }
  }, {
    key: "get_last",
    value: function get_last(id) {
      var _this13 = this;

      var lastPress = this.state.lastPress;

      var copy = Object.assign({}, this.state);
      copy.cells.forEach(function (value, key_y) {
        if (lastPress.id === value.id) {
          var cp_value = Object.assign({}, value);
          _this13.state.last_col = cp_value.defaultColumn;
          _this13.state.last_row = cp_value.defaultRow;
          _this13.state.colspan = cp_value.colspan;
          _this13.state.rowspan = cp_value.rowspan;
        }
      });
    }
  }, {
    key: "get_item_id",
    value: function get_item_id(id) {
      var copy = Object.assign({}, this.state);
      var result = null;
      copy.cells.forEach(function (value, key_y) {
        if (value.id === id) {
          result = Object.assign({}, value);
        }
      });
      return result;
    }
  }, {
    key: "get_item_between_forward",
    value: function get_item_between_forward(currentRow, currentCol) {
      // console.log("get_item_between_forward", currentRow, currentCol)
      var lastPress = this.state.lastPress;

      var lastPress_row = void 0,
          lastPress_col = void 0;
      // console.log("lastPress", lastPress)
      if (this.state.currentRow && this.state.currentCol) {
        lastPress_row = this.state.currentRow;
        lastPress_col = this.state.currentCol;
      } else {
        lastPress_row = lastPress.defaultRow;
        lastPress_col = lastPress.defaultColumn;
      }

      //verify is move to myself
      var res_is_owner = this.verify_is_owner(currentRow, currentCol);
      if (!res_is_owner && this.state.res_is_owner || !this.state.count_change) {
        lastPress_row = lastPress.defaultRow;
        lastPress_col = lastPress.defaultColumn;
      }

      var copy = Object.assign({}, this.state);
      var result = [];
      if (!res_is_owner) {
        copy.cells.forEach(function (value, key_y) {
          if (lastPress.id !== value.id) {
            if (value.defaultRow >= lastPress_row && value.defaultRow <= currentRow) {
              if (currentRow !== lastPress_row) {
                if (value.defaultColumn > lastPress_col && value.defaultRow === lastPress_row && value.defaultRow <= currentRow) {
                  // console.log("between1::>>>>>>>>>>>>", value.id)
                  result.push(value);
                }
                if (value.defaultRow > lastPress_row && value.defaultRow < currentRow) {
                  // console.log("between2::>>>>>>>>>>>>", value.id)
                  result.push(value);
                }
                if (value.defaultColumn <= currentCol && value.defaultRow === currentRow) {
                  // console.log("between3::>>>>>>>>>>>>", value.id)
                  result.push(value);
                }
              } else {
                if (value.defaultColumn > lastPress_col && value.defaultColumn <= currentCol && value.defaultRow <= currentRow) {
                  // console.log("between000::>>>>>>>>>>>>", value.id)
                  result.push(value);
                }
              }
            }
          }
        });
      }

      return result.sort(this.compare_forward);
    }
  }, {
    key: "compare_forward",
    value: function compare_forward(a, b) {
      if (a.defaultRow === b.defaultRow) {
        if (a.defaultColumn === b.defaultColumn) {
          return 0;
        }
        if (a.defaultColumn > b.defaultColumn) {
          return 1;
        } else {
          return -1;
        }
      }
      if (a.defaultRow > b.defaultRow) {
        return 1;
      } else {
        return -1;
      }
    }
  }, {
    key: "compare_back",
    value: function compare_back(a, b) {
      if (a.defaultRow === b.defaultRow) {
        if (a.defaultColumn === b.defaultColumn) {
          return 0;
        }
        if (a.defaultColumn > b.defaultColumn) {
          return -1;
        } else {
          return 1;
        }
      }
      if (a.defaultRow > b.defaultRow) {
        return -1;
      } else {
        return 1;
      }
    }
  }, {
    key: "get_item_between_back",
    value: function get_item_between_back(currentRow, currentCol) {
      //console.log("get_item_between_back", currentRow, currentCol, this.verify_is_owner(currentRow, currentCol), this.state.count_change)
      var lastPress = this.state.lastPress;

      var lastPress_row = void 0,
          lastPress_col = void 0;
      // console.log("lastPress", lastPress)
      if (this.state.currentRow && this.state.currentCol) {
        lastPress_row = this.state.currentRow;
        lastPress_col = this.state.currentCol;
      } else {
        lastPress_row = lastPress.defaultRow;
        lastPress_col = lastPress.defaultColumn;
      }

      var res_is_owner = this.verify_is_owner(currentRow, currentCol);
      if (!res_is_owner && this.state.res_is_owner || !this.state.count_change) {
        lastPress_row = lastPress.defaultRow;
        lastPress_col = lastPress.defaultColumn;
      }
      var result = [];
      if (!res_is_owner) {
        var copy = Object.assign({}, this.state);
        copy.cells.forEach(function (value, key_y) {
          if (lastPress.id !== value.id) {
            if (value.defaultRow <= lastPress_row && value.defaultRow >= currentRow) {
              if (currentRow !== lastPress_row) {
                if (value.defaultColumn < lastPress_col && value.defaultRow === lastPress_row && value.defaultRow >= currentRow) {
                  result.push(value);
                }
                if (value.defaultRow < lastPress_row && value.defaultRow > currentRow) {
                  result.push(value);
                }
                if (value.defaultColumn >= currentCol && value.defaultRow === currentRow) {
                  result.push(value);
                }
              } else {
                if (value.defaultColumn < lastPress_col && value.defaultColumn >= currentCol && value.defaultRow >= currentRow) {
                  result.push(value);
                }
              }
            }
          }
        });
      }
      return result.sort(this.compare_forward);
    }
  }, {
    key: "default_Sortable",
    value: function default_Sortable(currentRow, currentCol) {
      var _this14 = this;

      var lastPress = this.state.lastPress;

      this.get_last(lastPress.id);

      // console.log("this.state.currentCol", this.state.currentCol)
      if (this.state.currentCol) {
        // defaultColumn<<<<<<<<<<<<<<<<<<<<<
        if (currentCol < this.state.currentCol) {
          //console.log("currentCol", currentCol)
          this.get_item_left(currentRow, currentCol).forEach(function (value, key_y) {

            if (_this14.available_item_right(value, _this14.state.colspan)) {
              //console.log("move right:::", value)
              _this14.move_item_right(value, _this14.state.colspan);
            }
          });
          // console.log("this.available_item(currentRow, currentCol)", this.available_item(currentRow, currentCol))
          if (this.available_item(currentRow, currentCol)) {
            this.move_item_on_current_row_col(currentRow, currentCol);
          }
        }
        // defaultColumn>>>>>>>>>>>>>>>>>>>>>
        if (currentCol > this.state.currentCol) {
          //console.log("currentCol", currentCol)
          this.get_item_right(currentRow, currentCol).forEach(function (value, key_y) {
            if (_this14.available_item_left(value, _this14.state.colspan)) {
              _this14.move_item_left(value, _this14.state.colspan);
            }
          });
          // console.log("_______________")
          // console.log("this.available_item(currentRow, currentCol)", this.available_item(currentRow, currentCol))
          if (this.available_item(currentRow, currentCol)) {
            this.move_item_on_current_row_col(currentRow, currentCol);
          }
        }
      }
      if (this.state.currentRow) {
        //defaultRow---------------------------
        if (currentRow < this.state.currentRow) {
          this.get_item_top(currentRow, currentCol).forEach(function (value, key_y) {
            if (_this14.available_item_bottom(value, _this14.state.colspan)) {
              _this14.move_item_bottom(value, _this14.state.colspan);
            }
          });
          // console.log("this.available_item(currentRow, currentCol)", this.available_item(currentRow, currentCol))
          if (this.available_item(currentRow, currentCol)) {
            this.move_item_on_current_row_col(currentRow, currentCol);
          }
        }
        //defaultRow++++++++++++++++++++++++++++
        if (currentRow > this.state.currentRow) {
          this.get_item_bottom(currentRow, currentCol).forEach(function (value, key_y) {
            if (_this14.available_item_top(value, _this14.state.colspan)) {
              _this14.move_item_top(value, _this14.state.colspan);
            }
          });
          // console.log("this.available_item(currentRow, currentCol)", this.available_item(currentRow, currentCol))
          if (this.available_item(currentRow, currentCol)) {
            this.move_item_on_current_row_col(currentRow, currentCol);
          }
        }
      }
    }
  }, {
    key: "left_right_Sortable",
    value: function left_right_Sortable(currentRow, currentCol) {
      var _this15 = this;

      var lastPress = this.state.lastPress;

      var count_change = 0;
      this.get_last(lastPress.id);
      // console.log("mode::left_right_Sortable:::", currentRow, currentCol)

      if (currentCol > this.state.currentCol || currentRow > this.state.currentRow) {
        // console.log("COl:>>>>>>>>>>>>>>>>", Object.assign({}, this.state.cells))
        // console.log("available::", this.available_item_left_right(currentRow, currentCol))
        var value_to_left = [];
        if (!this.available_item_on_old_order(currentRow, currentCol)) {
          var search_value = this.when_available_item_left_right(currentRow, currentCol);
          if (search_value) {
            currentRow = search_value.defaultRow;
            currentCol = search_value.defaultColumn;
          }
          this.get_item_between_forward(currentRow, currentCol).forEach(function (value, key_y) {
            // console.log("get_item_between_forward ;; move_item_left :VALUE:", value)
            _this15.move_item_left(value, 1);
            count_change += 1;
            value_to_left.push(value);
          });
        }
        // console.log("available_item_left_right")
        if (this.available_item_left_right(currentRow, currentCol)) {
          this.move_item_on_current_row_col(currentRow, currentCol);
          count_change += 1;
        } else {
          value_to_left.forEach(function (value, key_y) {
            // console.log("value::", value)
            _this15.move_item_right(value, 1);
            count_change -= 1;
            // value_to_left.push(value)
          });
        }
      }
      if (currentCol < this.state.currentCol || currentRow < this.state.currentRow) {
        // console.log("back:<<<<<<<<<<<<<<<", Object.assign({}, this.state.cells))
        // console.log("available::", this.available_item_left_right(currentRow, currentCol))
        var value_to_right = [];
        if (!this.available_item_on_old_order(currentRow, currentCol)) {
          // console.log("return defaultColumn defaultRow for need item", this.when_available_item_left_right(currentRow, currentCol))
          var _search_value = this.when_available_item_left_right(currentRow, currentCol);
          if (_search_value) {
            currentRow = _search_value.defaultRow;
            currentCol = _search_value.defaultColumn;
          }
          this.get_item_between_back(currentRow, currentCol).forEach(function (value, key_y) {
            // console.log("value::", value)
            _this15.move_item_right(value, 1);
            count_change += 1;
            value_to_right.push(value);
          });
        }
        if (this.available_item_left_right(currentRow, currentCol)) {
          this.move_item_on_current_row_col(currentRow, currentCol);
          count_change += 1;
        } else {
          // console.log("return defaultColumn defaultRow for need item", this.when_available_item_left_right(currentRow, currentCol))
          value_to_right.forEach(function (value, key_y) {
            // console.log("value::", value)
            _this15.move_item_left(value, 1);
            count_change -= 1;
            // value_to_left.push(value)
          });
        }
      }
      return count_change;
    }
  }, {
    key: "handleMouseMove",
    value: function handleMouseMove(_ref) {
      var pageX = _ref.pageX,
          pageY = _ref.pageY;
      var _state = this.state,
          isPressed = _state.isPressed,
          topDeltaY = _state.topDeltaY,
          topDeltaX = _state.topDeltaX;


      if (isPressed) {
        var copy = Object.assign({}, this.state);
        var mouseY = pageY - topDeltaY;
        var currentRow = this.clamp(Math.round(mouseY / (this.state.cellHeight + this.state.cellSpacing)), 1, 10);

        var mouseX = pageX - topDeltaX;
        var currentCol = this.clamp(Math.round(mouseX / (this.state.cellWidth + this.state.cellSpacing)), 1, this.get_right_column_average(currentRow));

        // console.log("currentRow::", currentRow)
        // console.log("currentCol::", currentCol)

        var new_row = [];
        new_row = copy.cells;

        if (this.state.mode === "SWAP") {
          this.state.count_change = this.default_Sortable(currentRow, currentCol);
        }
        if (this.state.mode === "SORT") {
          this.state.count_change = this.left_right_Sortable(currentRow, currentCol);
        }

        if (currentRow !== this.state.currentRow) {
          this.state.currentRow = currentRow;
          this.state.res_is_owner = this.verify_is_owner(currentRow, currentCol);
        }
        if (currentCol !== this.state.currentCol) {
          this.state.currentCol = currentCol;
          this.state.res_is_owner = this.verify_is_owner(currentRow, currentCol);
        }

        this.state.mouseY = mouseY;
        this.state.mouseX = mouseX;
        this.state.cells = new_row;
      }
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown(pos, _ref2, _ref3) {
      var _ref4 = _slicedToArray(_ref2, 2),
          pressX = _ref4[0],
          pressY = _ref4[1];

      var pageX = _ref3.pageX,
          pageY = _ref3.pageY;

      this.state.lastPress = pos;
      this.state.isPressed = true;
      this.state.mouseY = pressY;
      this.state.mouseX = pressX;
      // let copy = Object.assign({}, this.state);
      // this.state.old_order = copy.cells;
      // console.log("this.state.old_order:::", this.state.old_order)
      this.state.old_order = this.clone(this.state.cells);
      this.state.topDeltaY = pageY - pressY;
      this.state.topDeltaX = pageX - pressX;
    }
  }, {
    key: "handleMouseUp",
    value: function handleMouseUp() {
      this.state.isPressed = false;
      this.state.topDeltaY = 0;
      this.state.topDeltaX = 0;
      this.state.currentCol = null;
      this.state.currentRow = null;
      this.state.old_order = this.clone(this.state.cells);
    }
  }]);

  return Sortable;
}();

exports.default = Sortable;


//////////////////
// WEBPACK FOOTER
// ./node_modules/develexe-sortable/distribution/index.js
// module id = 112
// module chunks = 0